<script>
	import PianoTile from './PianoTile.svelte';
</script>

<div>
	<PianoTile key='Q'/>
	<PianoTile key='W'/>
	<PianoTile key='E'/>
	<PianoTile key='R'/>
</div>

<style>
    div {
        display: flex;
        width:100%;
        height:20%;
        margin: 0px;
    }
</style>